/**
 * アプリケーションバージョン情報
 * このファイルは自動更新されます
 */

export const APP_VERSION = '2.0.62'
export const BUILD_TIME = '2025-09-09 07:45 JST'
export const COMMIT_HASH = 'de37bb1'
